import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpService } from './http.service';
import { Http,  Headers  } from '@angular/http';
import * as CryptoJS from 'crypto-js';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class SickLeaveListService {

  code = '';
  codeChallange = '';
  state = '';
  idToken: any;
  newRes: any;
  public userId;

  constructor(private httpService: HttpService, 
    private configService: ConfigService, 
    private http: Http) {
  }

  getIrregularitiesList() {
    const body = {
      'appLang': 'fr'
    };
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getirregularitylist', body);
    return this.httpService.post('/hradmin/getIrregularityList', body);
  }

  getHrAdminExpertList() {
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/gethradminexpertlist', {})
    return this.httpService.post('/hradmin/getHradminExpertList', {})
  }

  updateHrExpertAllocation(ids, hr_expert, userid) {
    const body = {
      'appLang': 'fr',
      'absenceids': ids
    };

    for (let i = 0; i < ids.length; i++) {
      if (hr_expert.role === 'ABSENCEEXPERT') {
        ids[i]['allocatedtoexpert'] = hr_expert.empid;
      } if (hr_expert.role === 'HRADMIN') {
        ids[i]['allocatedtohradmin'] = hr_expert.empid;
      }
      ids[i]['recordcreatedby'] = sessionStorage.getItem('user');
      ids[i].revisionkey = "" + ids[i].revisionkey;
    }

    body.absenceids = ids;
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/changeirregularitystatus', body)
    return this.httpService.post('/hradmin/changeIrregularityStatus', body)
  }

  checkForToken() {
    if (sessionStorage.getItem('sessionKey')) {
      console.log("Token is present")
      return true;
    } else {
      console.log("Token is absent")
      return false;
    }
  }

  /*extractTokenFromUrl() {
    let access_token;
    const results = new RegExp('[\?&#]id_token=([^&#]*)').exec(window.location.href);
    if (results) {
      access_token = results[1];
    } else {
      access_token = null;
    }
    return access_token;
  }

  redirectToSAB() {
    location.href = this.configService.get('redirect_url');
  }*/

  redirectToSAB() {
    this.codeChallange = this.generateCodeChallengeAndState();
    this.state = this.generateCodeChallengeAndState();

    let objdata = {
      "client_id": "AdminBpost4me",
      "response_type": "code",
      "scope": "openid",
      'redirect_uri': this.configService.get('redirect_url'),
      "code_challenge": this.codeChallange,
      "state": this.state
    }

    sessionStorage.setItem('code_challenge', this.codeChallange);
    sessionStorage.setItem('state', this.state);
    var url = this.configService.get('pingAuthURL') + '?' + this.serializeData(objdata);
    location.href = url;
  }

  serializeData = function (obj: any) {
    var str = [];
    for (var p in obj)
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    return str.join("&");
  }

  generateCodeChallengeAndState() {
    let code_Verifier = '';
    code_Verifier = this.generateRandomString(128);
    const cc = this.base64URL(CryptoJS.SHA256(code_Verifier))
    return cc;

  }

  base64URL(string: any) {
    return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  }
  generateRandomString(length: any) {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  callPingLoginService():any {  
    console.log("callPingLoginService");
    let auth_code_val = this.getParameterByName("code", window.location.href);
    let state_val = this.getParameterByName("state", window.location.href);

    if(!state_val || state_val != sessionStorage.getItem('state') || !auth_code_val) {
      console.log('error page');
      sessionStorage.clear();
      this.redirectToSAB();
      return false;
    }
    this.codeChallange = sessionStorage.getItem('code_challenge') || '';
   
    var obj = {
      "code": auth_code_val,
      "grant_type": "authorization_code",
      "client_id": "AdminBpost4me",
      "code_verifier": this.codeChallange,
      "redirect_uri": this.configService.get('redirect_url')
    }

    
    console.log(this.configService.get('pingTokenUrl'), this.serializeData(obj));

    this.http
      .post(this.configService.get('pingTokenUrl'), 
        this.serializeData(obj), 
        {headers : this.getHeaderForPing()})
      .subscribe((response:any) => {
        response=JSON.stringify(response);
        response=JSON.parse(response);
        this.idToken = JSON.parse(response._body).access_token;        
        sessionStorage.setItem('sessionKey', this.idToken);
        this.getInfo();
      },
      err => {
        console.log('error', err);
      }
    );
  }

  private getHeaderForPing(){
    let header = new Headers()
    header.append('Content-Type', 'application/x-www-form-urlencoded');
    return header;
  }

  public getParameterByName(name: string, url: string) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  getTheTokenFromStorage() {
    return sessionStorage.getItem('sessionKey');
  }

  sessionExpired() {
    alert('Session has expired!');
    sessionStorage.removeItem('sessionKey');
    sessionStorage.clear();
    this.redirectToSAB();
  }

  getInfo() {
    if (this.checkForToken()) {
      let token = sessionStorage.getItem('sessionKey');
      let details = jwt_decode(token);
      this.userId = details.employeeid;
      sessionStorage.setItem('user', details.employeeid);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/sick-leave-list.service.ts